import React from 'react';
import { Tabs, Tab, Form } from 'react-bootstrap';
import {
  isVisible
} from '../../utils/dynamicFormUtil';

const LivePreview = ({
  forms,
  activeTab,
  setActiveTab,
  setSelectedForm,
  previewValues,
  setPreviewValues
}) => {

  return (
    <>
      <h4>Live Preview</h4>
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => {
          setActiveTab(k);
          const matchedForm = forms.find((f) => f.id.toString() === k);
          if (matchedForm) setSelectedForm(matchedForm);
        }}
        className="mb-3"
      >
        {forms.map((form) =>
          isVisible(form, previewValues) ? (
            <Tab key={form.id} eventKey={form.id.toString()} title={form.name}>
              <Form>
                {form.fields.map((field) => {
                  if (!isVisible(field, previewValues)) return null;
                  return (
                    <Form.Group key={field.id} className="mb-3">
                      <Form.Label className={field.type === 'label' ? 'fw-bold' : ''} >
                        {field.label}{' '}
                        {field.required && <span className="text-danger">*</span>}
                      </Form.Label>

                      {field.type === 'text' && (
                        <Form.Control
                          type="text"
                          value={previewValues[field.id] || ''}
                          onChange={(e) =>
                            setPreviewValues({
                              ...previewValues,
                              [field.id]: e.target.value,
                            })
                          }
                          placeholder={field.placeholder}
                        />
                      )}

                      {(field.type === 'counter' || field.type === 'number') && (
                        <Form.Control
                          type="number"
                          value={previewValues[field.id] || ''}
                          min="0"
                          onChange={(e) =>
                            setPreviewValues({
                              ...previewValues,
                              [field.id]: e.target.value,
                            })
                          }
                        />
                      )}

                      {field.type === 'dropdown' && (
                        <Form.Select
                          value={previewValues[field.id] || ''}
                          onChange={(e) =>
                            setPreviewValues({
                              ...previewValues,
                              [field.id]: e.target.value,
                            })
                          }
                        >
                          <option value="">-- Select --</option>
                          {(field.options || []).map((opt, i) => (
                            <option key={i} value={opt}>{opt}</option>
                          ))}
                        </Form.Select>
                      )}

                      {field.type === 'radio' &&
                        (field.options || []).map((opt, i) => (
                          <Form.Check
                            key={i}
                            type="radio"
                            label={opt}
                            name={`field-${field.id}`}
                            value={opt}
                            checked={previewValues[field.id] === opt}
                            onChange={(e) =>
                              setPreviewValues({
                                ...previewValues,
                                [field.id]: e.target.value,
                              })
                            }
                          />
                        ))}

                      {field.type === 'checkbox' && (
                        <Form.Check
                          type="checkbox"
                          checked={!!previewValues[field.id]}
                          onChange={(e) =>
                            setPreviewValues({
                              ...previewValues,
                              [field.id]: e.target.checked,
                            })
                          }
                        />
                      )}

                      {field.type === 'image' && <div>(Image)</div>}
                    </Form.Group>
                  );
                })}
              </Form>
            </Tab>
          ) : null
        )}
      </Tabs>
    </>
  );
};

export default LivePreview;
